import Article from '~/components/Article';
import BigList, { BigListItem } from '~/components/BigList';
import Drawer from '~/components/SidebarDrawer';
import ToastsContainer from '~/containers/Toasts';
import * as client from '~/lib/client';

import styles from './Settings.style';
import EmailSettings from './settings/EmailSettings';
import HubspotSettings from './settings/HubspotSettings';
import MarketoSalesForm from './settings/MarketoSalesForm';
import SalesforceSettings from './settings/SalesforceSettings';
import WebhookSettings from './settings/WebhookSettings';

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: this.props.form,
      drawerView: null,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.form) {
      this.setState({ form: props.form });
    }
  }

  updateForm = (attrs, snackbarMessage = 'Settings saved') => {
    let form = Object.assign({}, this.state.form, attrs);

    this.setState({ form });

    return client
      .updateForm(form.id, attrs)
      .then(this.props.onChange)
      .then(() => {
        ToastsContainer.addSuccess(snackbarMessage);
      })
      .catch(this.onError);
  };

  onError = (response) => {
    const message = response.error.message;
    alert(message);
  };

  getDrawerViewComponent() {
    switch (this.state.drawerView) {
      case 'email':
        return EmailSettings;
      case 'marketo':
        return MarketoSalesForm;
      case 'hubspot':
        return HubspotSettings;
      case 'salesforce':
        return SalesforceSettings;
      case 'webhook':
        return WebhookSettings;
      default:
        break;
    }
  }

  setDrawerView(drawerView) {
    this.setState({ drawerView });
  }

  renderDrawerView() {
    let DrawerComponent = this.getDrawerViewComponent();
    if (!DrawerComponent) return;

    return (
      <DrawerComponent
        form={this.state.form}
        onUpdateForm={this.updateForm.bind(this)}
      />
    );
  }

  renderActions(type) {
    const { form } = this.state;
    const { classes } = this.props;
    const enabled = form[type + '_enabled'];

    let className = classnames(classes.status, {
      [classes.statusEnabled]: enabled,
    });

    return <div className={className}>{enabled ? 'Enabled' : 'Disabled'}</div>;
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Article>
          <BigList>
            <BigListItem
              onClick={this.setDrawerView.bind(this, 'email')}
              primary={'Email connector'}
              actions={this.renderActions('email')}
            />

            <BigListItem
              onClick={this.setDrawerView.bind(this, 'salesforce')}
              primary={'Salesforce connector'}
              actions={this.renderActions('salesforce')}
            />

            <BigListItem
              onClick={this.setDrawerView.bind(this, 'marketo')}
              primary={'Marketo connector'}
              actions={this.renderActions('marketo')}
            />

            <BigListItem
              onClick={this.setDrawerView.bind(this, 'hubspot')}
              primary={'HubSpot connector'}
              actions={this.renderActions('hubspot')}
            />

            <BigListItem
              onClick={this.setDrawerView.bind(this, 'webhook')}
              primary={'Webhook connector'}
              actions={this.renderActions('webhook')}
            />
          </BigList>
        </Article>

        <Drawer
          open={!!this.state.drawerView}
          onClose={this.setDrawerView.bind(this, null)}>
          {this.renderDrawerView()}
        </Drawer>
      </div>
    );
  }
}

Settings.propTypes = {
  form: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(Settings);
